import { Component, ElementRef, Input, Output, EventEmitter, ViewChild, Inject } from '@angular/core';
import {Jsonp, Http, Headers, URLSearchParams, RequestOptions, Response} from '@angular/http';
import Map = require('esri/Map');
import MapView = require('esri/views/MapView');
import Geometry = require('esri/geometry/Geometry');
import Point = require('esri/geometry/Point');
import Polygon = require('esri/geometry/Polygon');
import Polyline = require('esri/geometry/Polyline');
import Color = require('esri/Color');
import ScreenPoint = require('esri/geometry/ScreenPoint');
import MapImageLayer = require('esri/layers/MapImageLayer');
import TileLayer = require('esri/layers/TileLayer');
import Collection = require('esri/core/Collection');
import GraphicsLayer = require('esri/layers/GraphicsLayer');
import Graphic = require('esri/Graphic');
import SimpleMarkerSymbol = require('esri/symbols/SimpleMarkerSymbol');
import SimpleFillSymbol = require('esri/symbols/SimpleFillSymbol');
import SimpleLineSymbol = require('esri/symbols/SimpleLineSymbol');
import Sublayer = require('esri/layers/support/Sublayer');
import WatchUtils = require('esri/core/watchUtils');
import Basemap = require('esri/Basemap');
import Compass = require('esri/widgets/Compass');
import PopupTemplate = require('esri/PopupTemplate');
import on = require('dojo/on');
import {Config} from '../config';
import esriConfig = require('esri/config');
import {Subscription} from 'rxjs/Subscription';

import { MapService } from './map.service';
import { EventsService } from '../EventsService';
import { EsriTasksService } from '../esriTasks/esriTasks-service';
import {ParcelReportService} from '../tools/parcelReport.service';

@Component({
    selector: 'map-view',
    template: '<div class="mapViewDiv"><span #mapTooltipSpan *ngIf="showTooltip" class="mapTooltip">{{mapTooltipText}}</span><ng-content></ng-content></div>'// '<div style="position:fixed; height:100%; width:100%"></div>'
    //providers: [ParcelReportServiceProvider]
})
export class MapComponent {

    @Input() zoom: number;
    @Output() viewCreated = new EventEmitter();

    view: MapView = null;
    map: Map;
    
    subscription:Subscription;
    item: number;

    appSettings: Object = null;
    error: any;

    showTooltip:boolean = false;
    mapTooltipText:string = "";
    @ViewChild('mapTooltipSpan') mapTooltipSpan:ElementRef;
    mouseMoveTooltip:any;

    baseMap:Basemap;
    layerCollection:Collection = new Collection();

    _parcelReportService:ParcelReportService;
    parcelReportAction:any;

    private identifyPoint:Point;

    constructor(private elRef: ElementRef, private _mapService: MapService, private _eventsService:EventsService, private _esriTasksService:EsriTasksService, @Inject(ParcelReportService) prs, private http:Http) {
        this._parcelReportService = prs;
     }

    ngOnInit() {
        this.appSettings = Config.config[0];
        this.setUp();
        this._eventsService.showMapTooltip$.subscribe(parameters => {
            this.showTooltip = parameters["show"];
            this.mapTooltipText = parameters["tooltip"];
            if(this.showTooltip == true){
                this.mouseMoveTooltip = on(this._mapService.view.container, "mousemove", mmevt => {
                    var x = (mmevt.clientX + 20) + 'px',
                        y = (mmevt.clientY + 20) + 'px';
                    if(this.mapTooltipSpan){
                        this.mapTooltipSpan.nativeElement["style"].top = y;
                        this.mapTooltipSpan.nativeElement["style"].left = x;
                    }
                });

                // var popupTooltips = document.querySelectorAll('.esri-popup__main-container');
                // if(popupTooltips.length > 0){
                //     on(popupTooltips[0], "mousemove", mmevt => {
                //         this.mapTooltipSpan.nativeElement["style"].visibility = "hidden";
                //     });
                // }
                
            }else{
                this.mouseMoveTooltip.remove();
            }
        });
        esriConfig.request.proxyUrl = "ESRIProxy/proxy.ashx";
        // esriConfig.request.forceProxy = true;
    }

    setUp(){
        var baseMapServices:Array<any> = this.appSettings["Map"]["Layers"]["Base"];
        this.createBaseMap(baseMapServices);

        var statePlaneLayers:Array<any> = this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["layers"];
        statePlaneLayers.forEach(ms => {
            if(ms["id"] == this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["default"]){
                ms["opacity"] = this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["startOpacity"];
                this.createAndAddLayers([ms]);
            }
        });

        var operationalLayers:Array<any> = this.appSettings["Map"]["Layers"]["OperationalLayers"];
        operationalLayers.forEach(ms => {
            this.createAndAddLayers([ms]);
        });

        this._mapService.selGraphics = new GraphicsLayer({
            id: "selGraphics"
        });
        this._mapService.tempSelPlgGraphics = new GraphicsLayer({
            id: "tempSelPlgGraphics"
        });
        this._mapService.tempSelGraphics = new GraphicsLayer({
            id: "tempSelGraphics"
        });
        this._mapService.obliquePointGraphicLayer = new GraphicsLayer({
            id: "obliquePointGraphics"
        });
        this._mapService.popupSelectedFeatureGraphicLayer = new GraphicsLayer({
            id: "popupSelectedFeatureGraphics"
        });
        this._mapService.applyGeometryQueryGraphic = new GraphicsLayer({
            id: "applyGeometryQueryGraphic"
        });


        this.layerCollection.addMany([this._mapService.selGraphics, this._mapService.tempSelPlgGraphics, this._mapService.tempSelGraphics, this._mapService.obliquePointGraphicLayer, this._mapService.popupSelectedFeatureGraphicLayer, this._mapService.applyGeometryQueryGraphic]);
        
        this.map = new Map({
            "basemap":this.baseMap,
            "layers":this.layerCollection
        })

        this.view = this._mapService.view = new MapView({
            map: this.map
        });
        this.view.container = this.elRef.nativeElement.firstChild;
        this.view.constraints = {
            rotationEnabled: false
        }

        this.view.then(view => {
            var pt:Point = new Point({
                x: this.appSettings["Map"]["Center"]["x"],
                y: this.appSettings["Map"]["Center"]["y"],
            //    x: -9589883.136,
            //    y: 4835183.259,
               spatialReference: (view as MapView).spatialReference
            });
            view.center = pt;
            view.zoom = 4;
            //view.zoom = 11;

            //Remove compass since map rotation is disabled
            // var compasswidget = new Compass({
            //     view:this._mapService.view
            // });
            // this._mapService.view.ui.add(compasswidget, "top-left");
        });

        this.view.on("click", evt => {
            // evt is the event object returned after the event fires
            this._eventsService.mapClicked(evt);
        });

        this.view.on("layerview-create", event => {
            operationalLayers.forEach(ms => {
                if(event.layer.id === ms.id){
                    this._eventsService.dynamicLayerViewCreated();
                    return;
                }
            });
        });

        this.view.on("drag", evt => {
            this._eventsService.mapDrag(evt);
        });

        this.view.on("pointer-move", evt => {
            this._eventsService.mapPointerMove(evt);
        });

        this.view.on("pointer-down", evt => {
            this._eventsService.mapPointerDown(evt);
        });

        this.view.on("pointer-up", evt => {
            this._eventsService.mapPointerUp(evt);
        });

        this.view.on("double-click", evt => {
            this._eventsService.mapDoubleClick(evt);
        });

        this.view.watch("updating", value => {
            // setTimeout(() =>
            // {
            //     value ? this._eventsService.showDialog("updating map") : this._eventsService.hideDialog();
            // }, 200);
            this._eventsService.mapUpdateShow(value);
        });


        // Remove all popup actions cause for some reason Zoom To is not working (most likely because the spatial reference is messed up)
        this.view.popup.actions.removeAll();

        // Fires each time an action is clicked
        this.view.popup.viewModel.on("trigger-action", event => {
            // If the zoom-out action is clicked, then execute the following code
            if(event.action.id === "zoom-to-addon"){
                this._mapService.view.extent = event.target.selectedFeature.geometry.extent;
            }else if(event.action.id === "see-document"){
                var loadingImagePath:string = "./images/loading.gif";
                event.action["title"] = "Please wait...";
                event.action["className"] = "";
                event.action["id"] = "report-wait";
                this._esriTasksService.getServiceValues(this.appSettings["ResolutionFiles"]["serviceURL"] + "/" + event.action.extra.resolutionValue).then(resDocInfo => {
                    window.open(resDocInfo["FileUrl"], '_blank');
                    event.action["title"] = "See document";
                    event.action["className"] = "esri-icon-link-external";
                    event.action["id"] = "see-document";
                });
            }else if(event.action.id === "prc-card"){
                window.open(this.appSettings["PropertyRecordCards"]["URL"] + event.target.selectedFeature.attributes["Parcel Number"], '_blank');
            }else if(event.action.id === "parcel-report"){
                this.parcelReportAction = event.action;
                var loadingImagePath:string = "./images/loading.gif";
                event.action["className"] = "";
                event.action["title"] = "Generating report. Please wait...";
                event.action["image"] = loadingImagePath;
                event.action["id"] = "report-wait";
                this._parcelReportService = new ParcelReportService(this._esriTasksService, this._mapService, this._eventsService);
                this._parcelReportService.activeProject.subscribe(thing => 
                    {
                        if(thing["status"] != "ready"){
                            alert("Report creation for parcel " + thing["parcelNumber"] + " has failed. Please try again later or contact the application support team if the issue repeats.");
                        }
                        var parcelReportIconPath:string = "./images/parcel-report-icon.png";
                        event.action["image"] = parcelReportIconPath;
                        event.action["id"] = "parcel-report";
                        event.action["title"] = "Generate Parcel Report";
                    }
                );
                this._parcelReportService.startParcelReport(event.target.selectedFeature);
            }
        });


        this._mapService.view.watch("popup.selectedFeature", (newValue, oldValue) => {
            if(newValue != null){
                try{
                    this._mapService.view.popup.location = this.findPopupLocation(newValue.geometry);
                    this._mapService.popupSelectedFeatureGraphicLayer.graphics.removeAll();
                    var targetGraphic:Graphic = new Graphic();
                    targetGraphic.geometry = newValue.geometry;
                    var targetSymbol:SimpleFillSymbol = new SimpleFillSymbol();
                    targetSymbol.color = new Color(this.appSettings["IdentifyTool"]["SelectionSymbol"]["color"]);
                    targetSymbol.outline = new SimpleLineSymbol();
                    targetSymbol.outline.color = new Color(this.appSettings["IdentifyTool"]["SelectionSymbol"]["outline"]["color"]);
                    targetSymbol.outline.width = this.appSettings["IdentifyTool"]["SelectionSymbol"]["outline"]["width"];
                    targetGraphic.symbol = targetSymbol;
                    this._mapService.popupSelectedFeatureGraphicLayer.graphics.add(targetGraphic);
                }catch(ex){
                    console.log(ex);
                }
            }
        });
        this._mapService.view.watch("popup.visible", (newValue, oldValue) => {
            if(newValue == false){
                this._mapService.popupSelectedFeatureGraphicLayer.graphics.removeAll();
            }
        });

        this._eventsService.identifyLocationChanged$.subscribe(point => {
            this.identifyPoint = point;
        });
    } 

    private findPopupLocation(geometry:Geometry):Point
    {
        var point = new Point();
        if(geometry.type == "polyline"){
            let closestVertexDistance:number = 1000000;
            let closestVertex:Point = new Point({spatialReference: this._mapService.view.spatialReference});
            let polyline:Polyline = geometry as Polyline;
            let paths:Array<Array<Array<number>>> = polyline.paths;
            paths.forEach(multipoint => {
                multipoint.forEach(point => {
                    let distance:number = Math.sqrt(Math.pow((this.identifyPoint.x - point[0]), 2) + Math.pow((this.identifyPoint.y - point[1]), 2));
                    if(closestVertexDistance > distance){
                        closestVertexDistance = distance;
                        closestVertex.x = point[0];
                        closestVertex.y = point[1];
                    }
                });
            });
            point = closestVertex;
        }else if(geometry.type == "polygon"){
            if((geometry as Polygon).contains(this.identifyPoint)){
                point = this.identifyPoint;
            }else{
                let closestVertexDistance:number = 1000000;
                let closestVertex:Point = new Point({spatialReference: this._mapService.view.spatialReference});
                let polygon:Polygon = (geometry as Polygon);
                let rings:Array<Array<Array<number>>> = polygon.rings;
                rings.forEach(ring => {
                    ring.forEach(point => {
                        let distance:number = Math.sqrt(Math.pow((this.identifyPoint.x - point[0]), 2) + Math.pow((this.identifyPoint.y - point[1]), 2));
                        if(closestVertexDistance > distance){
                            closestVertexDistance = distance;
                            closestVertex.x = point[0];
                            closestVertex.y = point[1];
                        }
                    });
                });
                point = closestVertex; 
                //point = (geometry as Polygon).centroid;
            }
        }
        return point;
    }

    createBaseMap(baseMapLayerObj:Object){
        var baseMapLayer:TileLayer = new TileLayer({
            id:baseMapLayerObj["id"],
            url:baseMapLayerObj["url"],
            "opacity": baseMapLayerObj["opacity"]
        });
        var layerCollection:Collection = new Collection();
        layerCollection.add(baseMapLayer);
        this.baseMap = new Basemap({
            baseLayers: layerCollection
        });
    }

    createAndAddLayers(layersToAdd:Array<Object>){
        layersToAdd.forEach(mapService => {
            switch(mapService["type"]){
                case "tiled":
                    this.layerCollection.add(new TileLayer({
                        id:mapService["id"],
                        url:mapService["url"],
                        "opacity": mapService["opacity"]
                    }));
                    break;
                case "dynamic":
                    var miLayer:MapImageLayer = new MapImageLayer();
                    miLayer.id = mapService["id"];
                    miLayer.url = mapService["url"];
                    miLayer.visible = mapService["visible"];
                    miLayer.opacity = mapService["opacity"];
                    
                    // var subLayers:Collection = new Collection();
                    // var subLayer0:Object = {
                    //     id:0,
                    //     visible:true
                    // };
                    // var subLayer1:Object = {
                    //     id:1,
                    //     visible:false
                    // };
                    // var subLayer2:Sublayer = new Sublayer({
                    //     id:2,
                    //     visible:false
                    // });
                    // // var subSubLayers:Collection = new Collection();
                    // // for(var i:number = 0; i < 173; i++){
                    // //     var subSubLayer:Object = {
                    // //         id:i,
                    // //         visible:true
                    // //     }
                    // //     subSubLayers.add(subSubLayer);
                    // // }
                    // // subLayer2.sublayers = subSubLayers;
                    // var subLayer3:Object = {
                    //     id:3,
                    //     visible:false
                    // };
                    // subLayers.addMany([subLayer0, subLayer1, subLayer2, subLayer3]);
                    // //miLayer.sublayers = subLayers;



                    this.layerCollection.add(miLayer);

                    // layers.add(new MapImageLayer({
                    //     id:mapService["id"],
                    //     url:mapService["url"]
                    // }), mapService["order"]);
                    break;
            }
        });
    }

    // openResolutionDocument(resolution:string){
    //     return this.http.get(this.appSettings["ResolutionFiles"]["serviceURL"] + "/" + resolution)
    //         .toPromise()
    //         .then(res => {
    //             return res;
    //         })
    //         .catch(error => {
    //             alert("Error getting the resolution document. Please try again later.");
    //             return error;
    //         });
    // }

    eventsRegion(){
                // //map is loaded, then do some stuff
        // this.view.then(view => {
        //     var pt:Point = new Point({
        //        x: 189280,
        //        y: 1651766,
        //        spatialReference: 2965
        //     });
        //     view.center = pt;
        //     view.zoom = this.zoom;
        //     this.viewCreated.next(view);
        // });

        // this.view.on("click", evt => {
        //     this._eventsService.mapClicked(evt);
        // });

        // this._eventsService.mapClicked$.subscribe(evt => {
        //     var mapPoint:Point = evt.mapPoint;
        //     this.view.popup.open({
        //         title: "Location",
        //         location: evt.mapPoint,
        //         content: "X: " + mapPoint.x + "; " + "Y: " + mapPoint.y
        //     });
        // });
    }   

    // destroy map
    ngOnDestroy() {
        if (this.map) {
            (this.map as any).destroy();
        }
    }
}



// WEBPACK FOOTER //
// ./app/map-view/map.component.ts